<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="proses">
              <pageheader title="Attendance Data" title1="" />

              <div class="row">
                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>ID karyawan</label>
                    <input type="text" v-model="currentData.employee_id" placeholder="" />
                  </div>
                </div> -->
                <div class="col-lg-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Employee<span class="text-danger">*</span></label>
                    <vue-select :options="employeeList" :settings="{ settingOption: value, settingOption: value }"
                      v-model="currentData.employee_id" placeholder="None" required disabled>
                    </vue-select>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="currentData.tanggal" class="picker" :editable="true" :clearable="false"
                        required disabled />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Type of Attendance <span class="text-danger">*</span></label>
                    <vue-select :options="Jeniskehadiranlist" :settings="{ settingOption: value, settingOption: value }"
                      v-model="currentData.jenis_kehadiran" placeholder="None" required>
                    </vue-select>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock in <span class="text-danger">*</span></label>
                    <input type="time" class="form-control" v-model="currentData.jam_masuk" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12" v-if="setting_break_button == '1'">
                  <div class="form-group">
                    <label>Break Out <span class="text-danger">*</span></label>
                    <input type="time" class="form-control" v-model="currentData.jam_istirahat_keluar" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12" v-if="setting_break_button == '1'">
                  <div class="form-group">
                    <label>Break In <span class="text-danger">*</span></label>
                    <input type="time" class="form-control" v-model="currentData.jam_istirahat_masuk" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Clock out<span class="text-danger">*</span></label>
                    <input type="time" class="form-control" v-model="currentData.jam_pulang" required />
                  </div>
                </div>
                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Entrance Location</label>
                    <vue-select :options="LocationList" :settings="{ settingOption: value, settingOption: value }"
                      v-model="currentData.lokasi_masuk" placeholder="None">
                    </vue-select>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Exit Location</label>
                    <vue-select :options="LocationList" :settings="{ settingOption: value, settingOption: value }"
                      v-model="currentData.lokasi_pulang" placeholder="None">
                    </vue-select>
                  </div>
                </div> -->
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Entrance Address </label>
                    <textarea class="form-control" v-model="currentData.alamat_masuk">
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-12" v-if="setting_break_button == '1'">
                  <div class="form-group">
                    <label>Break Out Address </label>
                    <textarea class="form-control" v-model="currentData.alamat_istirahat_keluar">
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-12" v-if="setting_break_button == '1'">
                  <div class="form-group">
                    <label>Break in Address </label>
                    <textarea class="form-control" v-model="currentData.alamat_istirahat_masuk">
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Exit Address </label>
                    <textarea class="form-control" v-model="currentData.alamat_pulang">
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Notes </label>
                    <textarea class="form-control" v-model="currentData.notes">
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">update</button>
                  <router-link to="historyattendance" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import {base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch  } from "@/assets/js/function";


export default {
  
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Attendance Edit",
      title1: "update attendance",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",

      // select option
      TipeKerjaList: ["MONTH", "DAILY"],
      ShiftList: [],
      LocationList: [],
      AttendanceList: ["SCANQR", "SELFIE", "FINGERPRINT"],
      GenderList: ["MALE", "FEMALE"],
      ReligionList: ["ISLAM", "KRISTEN PROTESTAN", "KRISTEN KATOLIK", "HINDU", "BUDDHA", "KONGHUCU"],
      DepartementList: [],
      JobTitleList: [],
      employeeList: [],
      GolonganList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      StatusPajakList: [],

      //data
      currentData: {
        employee_id: "",
        tanggal: new Date(),
        jenis_kehadiran: "",
        jam_masuk: "",
        jam_pulang: "",
        jam_istirahat_masuk: "",
        jam_istirahat_keluar: "",
        
        alamat_masuk: "",
        alamat_pulang: "",
        alamat_istirahat_masuk: "",
        alamat_istirahat_keluar: "",
        notes: '',
        alasan: '',
      },
      currentDate: new Date,


      Computers: ["Computers", "Mac"],
      None: ["None", "option1"],
      Tax: ["Choose Tax", "2%"],
      Percentage: ["Percentage", "10%", "20%"],
      Piece: ["Piece", "Kg"],
      Active: ["Active", "Open"],
      Jeniskehadiranlist: [
        {
          "id": "HADIR",
          "text": "HADIR"
        },
        {
          "id": "IZIN",
          "text": "IZIN"
        },
        {
          "id": "TERLAMBAT",
          "text": "TERLAMBAT"
        },
        {
          "id": "CUTI",
          "text": "CUTI"
        },
        
      ],
      setting_break_button: "0",
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'update')

    this.namaCompany = localStorage.getItem('namaCompany');

    this.setting_break_button = JSON.parse(localStorage.getItem('setting_break_button'));

    //load employee data
    this.currentData = JSON.parse(localStorage.getItem('currentData'));
    this.currentData.tanggal = new Date(this.currentData.tanggal_asli);

    

    //set employee
    const employee = JSON.parse(localStorage.getItem('employeeList'));
    employee.forEach((value, index) => {
      const element = { id: value.id, text: value.nama }
      this.employeeList.push(element);
    });



  },
  
  methods: {
    
    scrollToInvalidElement() {
      const invalidElement = document.querySelector('.is-invalid');
      if (invalidElement && typeof invalidElement.scrollIntoView === 'function') {
        invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    formatCurrency(number, index) {
      this.currentData.salary[index].nilai = rupiahInput(number);
    },
    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocaly(dateInput) {
      const dateObj = new Date(dateInput);
      if (isNaN(dateObj.getTime())) return null; // Invalid date check

      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async proses() {
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      //set dob
      formData.delete("tanggal");
      formData.delete("tanggal_asli");

      if (this.currentData.tanggal != 'Invalid Date') {
        formData.append('tanggal', this.formatDateLocaly(this.currentData.tanggal));
        
      }

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // return true;

      const api = base_url + '/v3/attendances/update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      console.log('ini data edit', data)
      if(data.status){

        AlertBottom(data.message);
        goPage("historyattendance");

      }else {  
        AlertPopup2("error", "", data.message, true, 1500);
          
      }


      




    },
  },

};
</script>
